import { render, staticRenderFns } from "./PgccListagem.vue?vue&type=template&id=7e98ea85&scoped=true&"
import script from "./PgccListagem.vue?vue&type=script&lang=js&"
export * from "./PgccListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e98ea85",
  null
  
)

export default component.exports